module.exports = {
  pageTitle: 'Пользователи',
  add_user_button: 'Добавить пользователя',
  table: {
    userName: 'Имя пользователя',
    email: 'Логин',
    role: 'Роль пользователя',
    status: 'Статус',
    actions: 'Действия',
    delete: 'Удалить пользователя',
    edit: 'Редактировать пользователя',
    groups: 'Группы пользователей'
  },
  modal: {
    title_create: 'Добавить пользователя',
    username: 'Имя',
    login: 'Логин/Email',
    role: 'Роль',
    password: 'Пароль',
    save_button: 'Сохранить',
    name: 'Ваше имя',
    select_role: 'Выберете роль',
    select_enable: 'Статус',
    enabled: 'Активен',
    disabled: 'Неактивен',
    title_edit: 'Изменить пользователя',
    generate_password: 'Сгенерировать пароль',
    password_warning: 'Не забудьте сохранить пароль!',
    validation_rules_1: 'Требования к паролю',
    validation_rules_2: '-длина пароля не менее 12 символов;',
    validation_rules_3: '-содержится минимум 1 цифра;',
    validation_rules_4: '-содержится минимум 1 буква в верхнем регистре;',
    validation_rules_5: '-содержится минимум 1 буква в нижнем регистре;',
    groups: 'Группы пользователей'
  },
  errors: {
    required: 'Это поле обязательно',
    max_length: 'Максимальная длина 64 символа',
    invalid_characters: 'Недопустимые символы',
    password_too_short: 'Пароль меньше 12 символов',
    no_uppercase: 'Нет букв в верхнем регистре',
    no_lowercase: 'Нет букв в нижнем регистре',
    no_number: 'Нет чисел в пароле',
    no_special_char: 'Нет специальных символов',
    invalid_email: 'Неверный формат email'
  },
  toast: {
    success_delete: 'Пользователь успешно удален',
    success_add: 'Пользователь успешно добавлен',
    success_edit: 'Пользователь успешно изменен',
    error_while_edit: 'Ошибка при изменении пользователя:',
    error_while_add: 'Ошибка при добавлении пользователя:'
  },
  warning: 'Предупреждение',
  delete_user_text: 'Вы уверены что хотите удалить пользователя?',
  delete_user_text_ad_warning: 'При включенной синхронизации с AD данный пользователь может не добавиться затем автоматически.',
  navigation_bar: {
    users: 'Пользователи',
    users_groups: 'Группы пользователей',
    qm_users: 'Пользователи КК',
    users_synchronization: 'Синхронизации с AD'
  },
  add_user_group_button: 'Создать группу пользователей',
  users_groups_modal: {
    title: 'Группа пользователей',
    groupname: 'Имя группы',
    users: 'Пользователи',
    save_button: 'Сохранить',
    close_button: 'Отменить'
  },
  users_groups_table: {
    name: 'Название группы',
    members: 'Участников',
    actions: 'Действия'
  },
  delete_group_text: 'Вы уверены что хотите удалить группу пользователей?',
  qm: {
    roles: {
      controller: 'Контролёр',
      supervisor: 'Супервайзер',
      operator: 'Оператор',
      manager: 'Менеджер ОКК',
    },
    main_switcher: {
      active: 'Активные',
      deleted: 'Архив'
    },
    table: {
      username: 'Пользователь',
      role: 'роль',
      operator_id: 'ID оператора',
      actions: 'Действия',
      deleted: 'Активные'
    },
    form: {
      label: 'QM пользователь',
      name: 'Имя пользователя',
      role: 'Роль',
      operator_id: 'ID оператора',
      approve_button: 'Сохранить',
      cancel_button: 'Отменить'
    },
    user_search_placeholder: 'Введите имя пользователя',
  },
  user_search_placeholder: 'Введите имя пользователя',
  show_groups_desc: 'Отобразить пользователей группы:',
  AD_sync: {
    users: 'Пользователи',
    groups: 'Группы',
    period_sync: 'Периодическая синхронизация',
    forced_sync: 'Принудительная синхронизация',
    config: 'Конфигурация',
    period_sync_input_label: 'Период синхронизации в часах',
    name: 'Название',
    value: 'Значение',
    value_label: 'Пользователь / Группа пользователей',
    choose: 'Выберите...',
    add_config_elem: 'Добавить элемент конфигурации',
    save_config: 'Сохранить'
  }
}
